import React from 'react';
import { SOCIAL_BUTTON_LOGO_CONTAINER_CLASSNAME } from './constants';
import * as S from './styles';
import { SocialButtonProps } from './types';

/**
 * Social button typically used for authentication (OAuth) with the 3rd party.
 */
export const SocialButton: React.FC<SocialButtonProps> = ({
  children,
  className,
  fluid,
  isDisabled,
  logo,
  onPress,
  textAlign = 'center',
}) => (
  <S.Root {...{ className, fluid, isDisabled, onPress }} $textAlign={textAlign}>
    <S.LogoContainer className={SOCIAL_BUTTON_LOGO_CONTAINER_CLASSNAME}>
      {logo}
    </S.LogoContainer>
    {children}
  </S.Root>
);

export default SocialButton;
